export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT;

export const ADS_DOMAIN: string =
  ENVIRONMENT == "prd"
    ? "https://adtag.sphdigital.com"
    : "https://adtag-stg.sphdigital.com";

export const EPAPER_LINK = import.meta.env.VITE_EPAPER_LINK;

export const WEB2_BASE_URL = import.meta.env.VITE_WEB2_BASE_URL as string;

export const EPAPER_API_DOMAIN = import.meta.env.VITE_EPAPER_API_DOMAIN;

export const TM_PROD_DOMAIN = import.meta.env.VITE_TM_PROD_DOMAIN;

export const STORY_QUEUE_ID = import.meta.env.VITE_STORY_QUEUE_ID;

export const BC_ACCOUNT_ID = import.meta.env.VITE_BC_ACCOUNT_ID;
export const BC_PLAYER_ID = import.meta.env.VITE_BC_PLAYER_ID;

export const MYSPH_LIGHTBOX_URL = import.meta.env.VITE_MYSPH_LIGHTBOX_URL;
export const MYSPH_CLIENT_ID = import.meta.env.VITE_MYSPH_CLIENT_ID;
export const MYSPH_PUB_IDENTIFIER = import.meta.env.VITE_MYSPH_PUB_IDENTIFIER;

export const GRAPESHOT_API_ENDPOINT: string = import.meta.env
  .VITE_GRAPESHOT_API_ENDPOINT as string;

export const NEURON_EXTENDS = import.meta.env.VITE_NEURON_EXTENDS as string;

export const MBO_STORY_QUEUE_ID: string = import.meta.env
  .VITE_MBO_STORY_QUEUE_ID as string;

export const QUICKNEWS_FLAG = import.meta.env.VITE_QUICKNEWS_FLAG as string;

export const VWO_ACCOUNT_ID = import.meta.env.VITE_VWO_ACCOUNT_ID as string;
